import React from 'react';
import { Grid, Fade, Button } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import { translate } from '@monorepo/shared/node_modules/@lwtears/lwt-common-frontend/lib/@common/util';
import type {
  Asset,
  FeelingsMatchCard,
} from '@monorepo/shared/src/graph/schema-generated-types-student';
import { GuessStates, GuessImgSrcMap } from 'types';

type Card = FeelingsMatchCard & { removed?: boolean; flipped?: boolean };
interface Props {
  guessIndicator?: string;
  cardsRowOne: Card[];
  cardsRowTwo?: Card[];
  handleOnClick: (card: Card, row: number) => void;
  cardFront?: Asset;
}

const t = (key: string) => translate('activities', key);

const FeelingsMatchRoundLayout: React.FC<Props> = ({
  cardsRowOne,
  cardsRowTwo,
  handleOnClick,
  cardFront,
  guessIndicator = '',
}) => {
  const classes = styles();
  return (
    <div className={classes.container}>
      <Grid container spacing={6}>
        {cardsRowOne.map((card, index) => {
          return (
            <Grid
              key={card?.cardTouch?.id ?? index}
              item
              style={{ position: 'relative' }}
              xs={!cardFront ? 4 : 3}
            >
              {card && (
                <Button
                  className={card.removed ? classes.removed : classes.button}
                  onClick={() => handleOnClick(card, 1)}
                >
                  <img
                    alt={'alt'}
                    src={card.flipped || !cardFront ? card.cardBack?.src : cardFront.src}
                    id={`${card.cardTouch?.id}`}
                    className={
                      `${classes.cardImage}` +
                      ' ' +
                      (card.flipped ? `${classes.flipCard}` : `${classes.putInBack}`)
                    }
                  />
                </Button>
              )}
            </Grid>
          );
        })}
        {(cardsRowTwo || []).map((card, index) => (
          <Grid key={card?.cardTouch?.id ?? index} item style={{ position: 'relative' }} xs={3}>
            {card && (
              <Button
                className={card.removed ? classes.removed : classes.button}
                onClick={() => handleOnClick(card, 2)}
              >
                <img
                  alt={'alt'}
                  src={card.flipped ? card.cardBack?.src : cardFront?.src}
                  id={`${card.cardTouch?.id}`}
                  className={
                    `${classes.cardImage}` +
                    ' ' +
                    (card.flipped ? `${classes.flipCard}` : `${classes.putInBack}`)
                  }
                />
              </Button>
            )}
          </Grid>
        ))}
      </Grid>
      {guessIndicator && (
        <Fade in={guessIndicator !== GuessStates.NULL}>
          <img
            alt={t('feedbackImg')}
            className={classes.guessImg}
            src={GuessImgSrcMap[guessIndicator]}
          />
        </Fade>
      )}
    </div>
  );
};

const styles = makeStyles(() => ({
  container: {
    height: '100%',
    maxWidth: '1200px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    margin: 'auto',
  },
  feedbackImg: {
    left: 'calc(50% - 120px)',
    position: 'absolute',
    top: 'calc(50% - 120px)',
  },
  guessImg: {
    left: `calc(50% - 120px)`,
    position: 'absolute',
    top: `calc(50% - 120px)`,
  },
  button: {
    display: 'inline-block',
  },
  flipCard: {
    transform: 'rotateY(180deg) scaleX(-1)',
  },
  cardImage: {
    width: '90%',
    transition: 'all 0.3s ease 0s',
  },
  putInBack: {
    zIndex: -1,
  },
  removed: {
    display: 'none',
  },
}));

export default FeelingsMatchRoundLayout;
